import { DateTime } from "luxon";
import type { HospitalData } from "../utils/models";
export function demoReplaceNurse(
	parameters: Record<string, any>,
	hospitalData: HospitalData,
	addNurseToShift: any,
	removeNurseFromSpecificDate: any,
	prepareDataForAddNurse: any,
	findEligibleNurse: any,
	findNurseShiftDetails: any,
) {
	const { nurseId, date, demo_nurse_name } = parameters;
	const removeDate = date ? DateTime.fromISO(date) : DateTime.now();
	const originalNurse = hospitalData?.nurses?.find((n: any) => n.id === Number(nurseId));
	if (!originalNurse) return;

	const acceptingNurse = findEligibleNurse(originalNurse, hospitalData, removeDate);

	if (!acceptingNurse) return;
	// Hack: override the eligible nurse's name with the demo_nurse_name parameter
	if (demo_nurse_name) {
		acceptingNurse.firstName = demo_nurse_name.split(" ")[0] || demo_nurse_name;
		acceptingNurse.lastName = demo_nurse_name.split(" ").slice(1).join(" ") || "";
	}

	const shiftDetails = findNurseShiftDetails(originalNurse, hospitalData, removeDate);
	if (shiftDetails) {
		const { weekIndex, shiftNo, dayNo, nurseInShift } = shiftDetails;
		const nurseToAdd = prepareDataForAddNurse(
			hospitalData,
			weekIndex,
			dayNo,
			shiftNo,
			acceptingNurse.id,
			nurseInShift?.location,
			false,
			undefined,
			undefined,
			undefined,
			0,
		);
		if (nurseToAdd) {
			nurseToAdd.location = nurseInShift?.location;
			removeNurseFromSpecificDate(weekIndex, dayNo, shiftNo, originalNurse.id, false, nurseInShift?.id, true);
			addNurseToShift(nurseToAdd, weekIndex, dayNo, shiftNo, false, true);
		}
	}
}
